import React, { useEffect, useState } from "react";
import "./Result.css";
import Show from "./Show/Show";
import Search from "./Search/Search";
import pdfIcon from "../../../assets/pdf.svg";
import 'bootstrap/dist/css/bootstrap.min.css';

const Result = ({ items, handleSearch }) => {
  const [countShow, setCountShow] = useState(10);
  const [search, setSearch] = useState("");

  useEffect(() => {
    const timeout = setTimeout(() => {
      handleSearch(search);
    }, 500);

    return () => {
      clearTimeout(timeout);
    };
  }, [search]);

  return (
    <div className="result-container">
      {/* <div className="top-block">
        <Show setCountShow={setCountShow} />
        <Search setSearch={setSearch} />
      </div> */}

      <div className="table-main" id="result-table-main">
        <div className="table-main-header flex-block">
          <div className="table-main-header__header-name">Filename</div>
          <div className="table-main-header__header-name">Topic</div>
          <div className="table-main-header__header-name">Classification</div>
          <div
            className="table-main-header__header-name
          table-main-header__header-name--search"
          >
            <p className="table-main-header__header-summary">Summary</p>

            <input
              type="text"
              className="table-main-header__search"
              placeholder="Search"
              onChange={(e) => {
                const text = e.target.value;
                setSearch(text);
              }}
              value={search}
            />
          </div>
        </div>
        <div className="table-main-body">
          <div className="accordion " id="accordionResult">
            {items.length > 0 ? (
              items.map((item, index) => (
                <div className="table-main-item accordion-item" key={index}>
                  <h2 className="accordion-header" id={`flush-heading${index}`}>
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target={`#flush-collapse${index}`}
                      aria-expanded="false"
                      aria-controls={`flush-collapse${index}`}
                    >
                      <div className="flex-block">
                        <div className="body__item filename">
                          <img src={pdfIcon} />
                          {item.filename.substr(0, 15)}...
                        </div>
                        <div className="body__item">
                          {item.topic.substr(0, 15)}...
                        </div>
                        <div className="body__item">{item.classification.substr(0, 15)}...</div>
                        <div className="body__item">
                          {item.summary.substr(0, 80)}...
                        </div>
                      </div>
                    </button>
                  </h2>
                  <div
                    id={`flush-collapse${index}`}
                    className="accordion-collapse collapse"
                    aria-labelledby={`flush-heading${index}`}
                    data-bs-parent="#accordionResult"
                  >
                    <div className="table-main-item__body flex-block accordion-body">
                      {/* <div className="body__item filename body"><img src={pdfIcon} />{item.filename}</div> */}
                      <div>
                        {
                          item.url ? (<a
                            href={item.url}
                            target="_blank"
                            className="body__item filename body open"
                            rel="noreferrer"
                          >
                            <img src={pdfIcon} />
                            {item.filename}
                          </a>) : (<p
                            className="body__item filename body open no-url"
                            rel="noreferrer"
                          >
                            <img src={pdfIcon} />
                            {item.filename}
                          </p>)
                        }

                      </div>
                      <div className="body__item">{item.topic}</div>
                      <div className="body__item">{item.classification}</div>
                      <div className="body__item">{item.summary}</div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="empty">No data available in table-main</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Result;